module.exports = __webpack_public_path__ + "static/img/2020_welle1_02_aufeinanderschaun_quadrat.8c68c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gruene/2020_welle1_02_aufeinanderschaun_quadrat.png
// module id = 178
// module chunks = 1